// Voucher amounts are numeric in the database and whole dollars in practice, but
// the same number is rendered on the printed voucher, in the email, on the thank
// you screen and on the admin card. One copy of the rule so those can never
// disagree:
//
//   - show cents only when there are any — "$150.00" on a gift reads like an
//     invoice, while 87.50 must not collapse to "$87.5";
//   - normalise, never echo. The purchaser types into a number field and "0150"
//     is a real thing to type; it is $150, not "$0150".
//
// Anything that isn't a number at all is passed through as text rather than
// printed as "NaN" — a legacy row with something odd in it should still read.
//
// Nothing at all is the one case that must not become a number. Number(null)
// and Number('') are both 0, so an amount that simply hasn't been set would
// otherwise print as a confident "$0" next to a voucher that is worth $200.
// Empty in, empty out; the caller decides what to say about it.
export const formatAmount = (amount) => {
  if (amount === null || amount === undefined || amount === '') return '';
  const n = Number(amount);
  if (!Number.isFinite(n)) return String(amount);
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
};

// Balances are held in cents as integers on purpose — a voucher part-spent
// three times must still add up to the cent, and 0.1 + 0.2 does not. Cents are
// the only thing that ever gets stored or sent; dollars exist for reading.
export const formatCents = (cents) => {
  if (cents === null || cents === undefined || cents === '') return '';
  const n = Number(cents);
  if (!Number.isFinite(n)) return '';
  return formatAmount(n / 100);
};

// Dollars as typed → whole cents, or null when there is nothing usable in the
// box. Null is a meaningful answer here rather than a failure: an empty amount
// on the redeem form means "whatever is left", which is the common case.
// Rounded, because 45.55 * 100 is 4554.999999999999 in floating point.
export const dollarsToCents = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const n = Number(String(value).trim().replace(/^\$/, ''));
  if (!Number.isFinite(n) || n <= 0) return NaN;
  return Math.round(n * 100);
};

export default formatAmount;
